import { Cookies } from "react-cookie";
import { GenericObject } from "../custom-types/generic-object";
import { FB_PIXEL_ID, FB_CAPI_TOKEN, COOKIES } from "../constants/misc";

interface GaSendEventParams {
    eventCategory: string;
    eventAction: string;
    eventLabel: string;
    eventValue?: number;
    fieldsObject?: GenericObject;
}

function uaSendEvent(params: GaSendEventParams) {
    const ga = window.ga;
    if (!ga) {
        return;
    }
    const trackerName = ga.getAll?.()?.[0]?.get?.("name");
    if (!trackerName) {
        return;
    }
    ga(`${trackerName}.send`, {
        hitType: "event",
        ...params
    });
}

export function ga4sendEvent(eventName: string, params: GenericObject) {
    const { gtag } = window;
    if (!gtag) {
        return;
    }
    gtag("event", eventName, params);
}

export function gaSendEvent(params: GaSendEventParams) {
    uaSendEvent(params);
}

export function ga4SetUser(userId: string | number) {
    const cookies = new Cookies();
    const { gtag } = window;
    if (!gtag) {
        return;
    }
    gtag("set", { user_id: cookies.get(COOKIES.userId) });
}

export function moEngageUserAttributeTrack(attribute: string, value: any) {
    const moEngage = window["Moengage"];
    if (attribute && value && moEngage) {
        moEngage.add_user_attribute(attribute, value);
    }
}

export function moEngageUserEventTrack(eventName: string, attributes: any) {
    const moEngage = window["Moengage"];
    if (eventName && attributes && moEngage) {
        moEngage.track_event(eventName, attributes);
    }
}

export function moEngageUserLogIn(userId: number) {
    const moEngage = window["Moengage"];
    if (userId && moEngage) {
        moEngage.add_unique_user_id(userId);
    }
}
export function moEngageUserLogOut() {
    const moEngage = window["Moengage"];
    if (moEngage) {
        moEngage.destroy_session();
    }
}
export function moEngageUserPhoneNum(phoneNum: string | number) {
    const moEngage = window["Moengage"];
    if (phoneNum && moEngage) {
        moEngage.add_mobile(phoneNum);
    }
}

export function sendPageSenseEvent(eventName: string) {
    window.pagesense = window.pagesense || [];
    const pagesense = window["pagesense"];
    if (pagesense) {
        window.pagesense.push(["trackEvent", eventName]);
    }
}

export function getFBEventId(id?: number | string, companyId?: number | string) {
    const suffix =
        typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    return [id, companyId, suffix].filter((part) => part != null && part !== "").join("_");
}

interface SendFbCapiEventParams {
    event_id: string;
    event_name: string;
    phone_num?: number | string;
    custom_data?: GenericObject;
}

export async function sendFbCapiEvent(params: SendFbCapiEventParams) {
    const cookies = new Cookies();
    const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
    const sha256 = (await import("crypto-js/sha256")).default;

    const urlencoded = new URLSearchParams();
    if (ENV !== "production") {
        urlencoded.append("test_event_code", "TEST15638");
    }
    const currLocObj = cookies.get(COOKIES.currentLoc);

    let currCity;
    if (currLocObj) {
        currCity = currLocObj.name;
    }
    urlencoded.append(
        "data",
        JSON.stringify([
            {
                event_id: params.event_id,
                event_name: params.event_name,
                event_time: Math.round(new Date().getTime() / 1000),
                action_source: "website",
                event_source_url: window.location.href,
                user_data: {
                    ph: params.phone_num ? sha256(String(params.phone_num)).toString() : undefined,
                    ct: currCity ? sha256(currCity).toString() : undefined,
                    country: sha256(String("in")).toString(),
                    fbp: cookies.get("_fbp") ? cookies.get("_fbp") : undefined,
                    fbc: cookies.get("_fbc") ? cookies.get("_fbc") : undefined
                },
                custom_data: params.custom_data
            }
        ])
    );
    fetch(`https://graph.facebook.com/v23.0/${FB_PIXEL_ID}/events?access_token=${FB_CAPI_TOKEN}`, {
        method: "POST",
        body: urlencoded,
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });
}
